
import { defineComponent, onMounted } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  setup () {
    const router = useRoute()

    const index = () => {
      if (router.query.token && router.query.id) {
        window.localStorage.setItem('PPORT_TOKEN', router.query.token.toString())
        window.localStorage.setItem('PPORT_ID', router.query.id.toString())
        window.location.href = '/dashboard'
        return
      }

      if (!window.localStorage.getItem('PPORT_TOKEN')) {
        window.location.href = '/login'
      } else {
        window.location.href = '/dashboard'
      }
    }

    onMounted(index)
  }
})
